import React from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import PageContainer from '../../common/components/Page/PageContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import ReportRendererContainer from '../../common/components/ReportRenderer/ReportRendererContainer';
import { connect } from 'react-redux';
import moment from 'moment';

const SubscriptionManagement = (props) => {
  let dtRange = props.globalDateTime;
  return (
    <PageContainer pageName="subscription-management">
      <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_BILLING}>
        <div>
          {dtRange == null
            ? loadReport()
            : loadReport(dtRange.startDate, dtRange.endDate, dtRange.setByReportName)}
        </div>
      </PermissionsCheck>
    </PageContainer>
  );
};

function loadReport(startDate, endDate, reportName) {
  var query = {
    ReportName: 'subscriptionManagement',
  };

  if (startDate != undefined && endDate != undefined && reportName != query.ReportName) {
    query.StartDate = moment.utc().startOf('month').subtract(3, 'months').format();
    query.EndDate = moment.utc().startOf('month').format();
  }

  return <ReportRendererContainer query={query} />;
}

function mapStateToProps(state) {
  return { globalDateTime: state.globalDateTime };
}

export default withRouter(connect(mapStateToProps)(SubscriptionManagement));
